module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-forum-thread panel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "thread-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newThread.title),
      expression: "newThread.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Thread Title"
    },
    domProps: {
      "value": (_vm.newThread.title)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newThread.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "thread-category"
  }, [_c('DropdownSelect', {
    attrs: {
      "placeholder": "Select a category",
      "options": _vm.categoryOptions
    },
    model: {
      value: (_vm.newThread.categoryId),
      callback: function($$v) {
        _vm.newThread.categoryId = $$v
      },
      expression: "newThread.categoryId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "discussion"
  }, [_c('div', {
    staticClass: "posts-column"
  }, [_c('ForumPost', {
    ref: "post",
    attrs: {
      "post": _vm.initialPost,
      "isEditing": true
    }
  }, [_c('template', {
    attrs: {
      "slot": "stopEditorButton"
    },
    slot: "stopEditorButton"
  }), _vm._v(" "), _c('template', {
    attrs: {
      "slot": "saveEditorButton"
    },
    slot: "saveEditorButton"
  }, [_c('button', {
    staticClass: "btn-primary",
    attrs: {
      "disabled": !_vm.canCreateThread,
      "title": _vm.creationStatusMessage
    },
    on: {
      "click": function($event) {
        _vm.createThread()
      }
    }
  }, [_vm._v("\n                            Create thread\n                        ")])])], 2), _vm._v(" "), _c('ForumThreadSummary', {
    ref: "summary",
    attrs: {
      "isEditing": true,
      "canSave": false,
      "termTypes": _vm.newThread.termTypes,
      "pathIds": _vm.newThread.pathIds,
      "assignmentIds": _vm.newThread.assignmentIds,
      "tagNames": _vm.newThread.tagNames
    },
    on: {
      "update:termTypes": function($event) {
        _vm.newThread.termTypes = $event
      },
      "update:pathIds": function($event) {
        _vm.newThread.pathIds = $event
      },
      "update:assignmentIds": function($event) {
        _vm.newThread.assignmentIds = $event
      },
      "update:tagNames": function($event) {
        _vm.newThread.tagNames = $event
      }
    }
  }), _vm._v(" "), _c('hr')], 1), _vm._v(" "), _c('div', {
    staticClass: "pre-timeline-spacer flex-full"
  }), _vm._v(" "), _c('ForumThreadTimeline', {
    attrs: {
      "posts": _vm.timelinePosts
    },
    model: {
      value: (_vm.timelineValue),
      callback: function($$v) {
        _vm.timelineValue = $$v
      },
      expression: "timelineValue"
    }
  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('Loader')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-616fbaf5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewForumThread.vue
// module id = 2058
// module chunks = 2